// extracted by mini-css-extract-plugin
export default {"admin":"style_admin__AtrAb","admin__content":"style_admin__content__efkED"};